import { Progress } from "antd";

const FEEDBACK = {
  1: { emoji: "😕", text: "Weak: Add uppercase, lowercase, numbers & special characters", color: "text-gray-600" },
  2: { emoji: "😐", text: "Medium: Try adding special characters (!@#$%) for a stronger password", color: "text-gray-600" },
  3: { emoji: "😊", text: "Strong: Great password!", color: "text-green-600 font-medium" },
};

const PasswordStrengthMeter = ({ password, strength }) => {
  if (!password) return null;

  const feedback = FEEDBACK[strength.score];

  return (
    <div className="mb-4 -mt-2">
      <Progress
        percent={strength.percentage}
        strokeColor={strength.color}
        showInfo={false}
        strokeWidth={6}
        className="mb-2"
      />
      {feedback && (
        <div className="flex items-center gap-2">
          <span className="text-xl">{feedback.emoji}</span>
          <span className={`text-sm ${feedback.color}`}>{feedback.text}</span>
        </div>
      )}
    </div>
  );
};

export default PasswordStrengthMeter;
